/* eslint-disable no-prototype-builtins */
import { Tab } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Tabs from "@mui/material/Tabs";
import React, { useEffect } from "react";

import Button from "../../../../../../../design/button";
import DialogWrapper from "../../../../../../../design/dialog-wrapper";
import ForcedOvertime from "./forced-overtime";
// import ConfigurationForm from "./configuration-form";
import VoluntarySignup from "./voluntary-signup";

type ConfigurationDialogProps = {
	open: boolean;
	handleClose: () => void;
	shiftAllocationRules: any;
	setShiftAllocationRules: any;
	// id?: number;
	locationData: any;
	setLocationData: any;
	// title: string;
	allocationTypeDetails: any;
	initialRules: any;
};

const ConfigurationDialog = ({
	open,
	handleClose,
	shiftAllocationRules,
	setShiftAllocationRules,
	locationData,
	setLocationData,
	allocationTypeDetails,
	initialRules,
}: ConfigurationDialogProps) => {
	const config = shiftAllocationRules.find(
		(rule: { shiftAllocationTypeId: number }) =>
			rule.shiftAllocationTypeId === allocationTypeDetails?.id
	);
	const [value, setValue] = React.useState(0);
	const initialConfig = initialRules.find(
		(rule: { shiftAllocationTypeId: number }) =>
			rule.shiftAllocationTypeId === allocationTypeDetails?.id
	);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	function TabPanel(props: any) {
		const { children, value, index, ...other } = props;

		return (
			<div
				role='tabpanel'
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
				style={{
					height: "100%",
					overflow: "auto"
				}}
			>
				{value === index && <Box sx={{ p: 3, pb: 1 }}>{children}</Box>}
			</div>
		);
	}

	const isFastest = allocationTypeDetails?.type === "FASTEST";

	const forcedOvertime = (
		<ForcedOvertime
			config={config}
			shiftAllocationRules={shiftAllocationRules}
			setShiftAllocationRules={setShiftAllocationRules}
			id={allocationTypeDetails?.id}
			forcedOTRules={allocationTypeDetails?.forcedOTRules}
			allocationType={allocationTypeDetails?.type}
		/>
	);

	const onDialogClose = () => {
		handleClose();
		setShiftAllocationRules(() => {
			return shiftAllocationRules.map((rule: any) => {
				if (rule.shiftAllocationTypeId === allocationTypeDetails?.id) {
					return initialRules.find(
						(initialRule: any) =>
							initialRule.shiftAllocationTypeId === allocationTypeDetails?.id
					);
				}
				return rule;
			});
		});
		setValue(0);
	};

	return (
		<Dialog
			open={open}
			onClose={onDialogClose}
			aria-describedby='alert-dialog-slide-description'
			maxWidth={false}
		>
			<DialogWrapper
				// dialogTitle='Worker Type and Location based allocation - configuration'
				dialogTitle={allocationTypeDetails?.dialogTitle}
				dialogSubTitle={
					"Configure the rules that you want to apply for the shift allocation"
				}
				dialogContent={
					isFastest ? (
						// Fastest Acceptance has no voluntary signup settings, so the
						// Supervisor Assignment section is shown without tabs
						<Box
							sx={{
								width: "965px",
								height: "400px",
								overflow: "auto",
								pb: 1,
							}}
						>
							{forcedOvertime}
						</Box>
					) : (
						<Box
							sx={{
								width: "965px",
								display: "flex",
								flexDirection: "column",
								height: "400px",
							}}
						>
							{/* Sticky Tabs Container */}
							<Box
								sx={{
									position: "sticky",
									top: 0,
									zIndex: 1,
									backgroundColor: "background.paper",
									borderBottom: "1px solid",
									borderColor: "divider",
								}}
							>
								<Tabs
									value={value}
									onChange={handleChange}
									aria-label='simple tabs example'
								>
									<Tab label='Voluntary Signup' />
									<Tab label='Supervisor Assignment' />
								</Tabs>
							</Box>

							{/* Scrollable Content Container */}
							<Box
								sx={{
									flex: 1,
									overflow: "auto",
									position: "relative",
								}}
							>
								<TabPanel value={value} index={0}>
									<VoluntarySignup
										shiftAllocationRules={shiftAllocationRules}
										setShiftAllocationRules={setShiftAllocationRules}
										id={allocationTypeDetails?.id}
										config={config}
										voluntaryRules={allocationTypeDetails?.voluntaryRules}
										allocationType={allocationTypeDetails?.type}
									/>
								</TabPanel>
								<TabPanel value={value} index={1}>
									{forcedOvertime}
								</TabPanel>
							</Box>
						</Box>
					)
				}
				actionButtons={
					<Box
						display='flex'
						justifyContent='space-between'
						width='160px'
						mt={-5}
					>
						<Button color='primary' variant='text' onClick={onDialogClose}>
							Cancel
						</Button>
						<Button
							variant='contained'
							color='primary'
							type='submit'
							onClick={() => {
								setLocationData({
									...locationData,
									allocationSettings: shiftAllocationRules,
								});
								onDialogClose();
							}}
							disabled={
								JSON.stringify(initialConfig) === JSON.stringify(config)
							}
						>
							Done
						</Button>
					</Box>
				}
			/>
		</Dialog>
	);
};

export default ConfigurationDialog;
